(function () {
  const initHeader = (root = document) => {
    root.querySelectorAll('[data-mr-header]').forEach((header) => {
      if (header.dataset.mrReady) return;
      header.dataset.mrReady = 'true';
      const shell = header.closest('.mr-header-shell');
      const dropdown = shell?.querySelector('.mr-header__dropdown');
      const shopTriggers = shell?.querySelectorAll('[data-mr-shop-trigger]') || [];
      const drawer = document.querySelector('[data-mr-drawer]');
      const drawerOpen = shell?.querySelector('[data-mr-drawer-open]');
      const drawerClose = drawer?.querySelectorAll('[data-mr-drawer-close]') || [];

      shopTriggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => dropdown?.classList.add('is-open'));
        trigger.addEventListener('focus', () => dropdown?.classList.add('is-open'));
      });
      shell?.addEventListener('mouseleave', () => dropdown?.classList.remove('is-open'));
      const closeDrawer = () => {
        drawer?.classList.remove('is-open');
        drawer?.setAttribute('aria-hidden', 'true');
        drawerOpen?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mr-menu-open');
      };
      const openDrawer = () => {
        drawer?.classList.add('is-open');
        drawer?.setAttribute('aria-hidden', 'false');
        drawerOpen?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('mr-menu-open');
      };
      drawerOpen?.addEventListener('click', openDrawer);
      drawerClose.forEach((el) => el.addEventListener('click', closeDrawer));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
      });

      if (shell?.dataset.overlayHome === 'true') {
        const scrollRoot = document.querySelector('.page-wrapper');
        const update = () => {
          const scrollTop = scrollRoot instanceof HTMLElement ? scrollRoot.scrollTop : window.scrollY;
          const scrolled = scrollTop > 40;
          header.classList.toggle('is-scrolled', scrolled);
          shell?.classList.toggle('is-scrolled', scrolled);
        };
        update();
        scrollRoot?.addEventListener('scroll', update, { passive: true });
        window.addEventListener('scroll', update, { passive: true });
      }
    });
  };

  const initProduct = (root = document) => {
    root.querySelectorAll('[data-mr-product]').forEach((section) => {
      if (section.dataset.mrReady) return;
      section.dataset.mrReady = 'true';
      const variantsNode = section.querySelector('[data-mr-variants]');
      const form = section.querySelector('form[action*="/cart/add"]');
      const variantInput = form?.querySelector('input[name="id"]');
      const price = section.querySelector('[data-mr-price]');
      const compare = section.querySelector('[data-mr-compare-price]');
      const button = section.querySelector('[data-mr-buy]');
      const media = section.querySelectorAll('[data-variant-media-id]');
      if (!variantsNode || !variantInput) return;
      let variants = [];
      try { variants = JSON.parse(variantsNode.textContent); } catch (_) { return; }

      const controls = Array.from(section.querySelectorAll('[data-mr-option]'));
      const selectedOptions = () => controls.map((control) => {
        if (control.matches('select')) return control.value;
        const checked = section.querySelector(`input[name="${CSS.escape(control.dataset.mrOption)}"]:checked`);
        return checked?.value || '';
      });
      const updateVariant = () => {
        const selected = selectedOptions();
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) {
          button.disabled = true;
          button.textContent = button.dataset.unavailableText || 'Unavailable';
          return;
        }
        variantInput.value = variant.id;
        if (price) price.textContent = variant.price_formatted;
        if (compare) {
          compare.textContent = variant.compare_at_price_formatted || '';
          compare.hidden = !variant.compare_at_price_formatted;
        }
        button.disabled = !variant.available;
        button.textContent = variant.available ? `${button.dataset.addText || 'Add to bag'} — ${variant.price_formatted}` : (button.dataset.soldText || 'Sold out');
        controls.forEach((control) => {
          const label = control.querySelector('.mr-pdp__option-head span:last-child');
          if (!label) return;
          if (control.matches('select')) label.textContent = control.value;
          else {
            const checked = section.querySelector(`input[name="${CSS.escape(control.dataset.mrOption)}"]:checked`);
            if (checked) label.textContent = checked.value;
          }
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        if (variant.featured_media_id) {
          const target = Array.from(media).find((item) => Number(item.dataset.variantMediaId) === Number(variant.featured_media_id));
          target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      };
      controls.forEach((control) => control.addEventListener('change', updateVariant));
    });
  };

  const initSort = (root = document) => {
    root.querySelectorAll('[data-mr-sort]').forEach((select) => {
      if (select.dataset.mrReady) return;
      select.dataset.mrReady = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
  };

  const init = (root = document) => {
    initHeader(root);
    initProduct(root);
    initSort(root);
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

document.addEventListener('shopify:section:unload', () => {
  document.body.classList.remove('mr-menu-open');
  document.documentElement.style.overflow = '';
});
window.addEventListener('pageshow', () => {
  document.body.classList.remove('mr-menu-open');
  document.documentElement.style.overflow = '';
});
